module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Poisoned_Ground2#Contents-A"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("As always, I owe my thanks to many people who made the writing and publication of this book possible:")]), _vm._v(" "), _c('p', {
    staticClass: "Indent para-style-override-3"
  }, [_vm._v("My husband, Jerry Parshall, and my friends Carol Baier and Cathrine Dubie for reading and critiquing the manuscript;")]), _vm._v(" "), _c('p', {
    staticClass: "Indent para-style-override-3"
  }, [_c('span', [_vm._v("My editor, Barbara Peters, for her perspective and guidance;")])]), _vm._v(" "), _c('p', {
    staticClass: "Indent para-style-override-3"
  }, [_vm._v("Jessica Tribble, Nan Beams, Suzan Baroni, and the rest of the crew at Poisoned Pen Press;")]), _vm._v(" "), _c('p', {
    staticClass: "Indent para-style-override-3"
  }, [_vm._v("My friends in Sisters in Crime and Mystery Writers of America, who freely share their expertise in many professional fields and on a staggering range of topics;")]), _vm._v(" "), _c('p', {
    staticClass: "Indent para-style-override-3"
  }, [_vm._v("And, most of all, my readers, whose notes of appreciation and encouragement make me believe the effort is worthwhile.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }), _vm._v(" "), _c('p', {
    staticClass: "body"
  }), _vm._v(" "), _c('p', {
    staticClass: "body"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69b1b470","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Poisoned_Ground-4.vue
// module id = 72
// module chunks = 0